// src/pages/TestResult.jsx
import React, { useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
//import jsPDF from "jspdf";
//import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function TestResult() {
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const { id } = useParams();
  const pdfRef = useRef(null);
  
  const {
    test,
    answers = {},
    score = 0,
    total = 0,
  } = routerLocation.state || {};

  if (!routerLocation.state || !test) {
    return (
      <p className="text-center mt-10 text-red-500 font-semibold text-xl">
        ❌ No result data found. Please take the test first.
      </p>
    );
  }

//============== CALCULATIONS =================
const getCorrectAnswer = (q) => {

  if (q.type === "mcq") {
    return q.options.findIndex(
      opt => opt.key === q.answer
    );
  }

  if (q.type === "truefalse") {
    return q.options.findIndex(
      opt =>
        opt.text.toLowerCase() ===
        q.answer.toLowerCase()
    );
  }

  if (q.type === "text") {
    return q.answer;
  }

  return null;
};


  // ================= STATUS =================

  const getStatus = (q) => {
    const userAns = answers[q._id];

    if (userAns === undefined) return "skipped";

    if (q.type === "text") {
  if (
    userAns?.toLowerCase().trim() ===
    q.answer?.toLowerCase().trim()
  ) return "correct";
}
else {
  if (userAns === getCorrectAnswer(q)) return "correct";
}

    return "wrong";
  };

  // ================= COUNTS =================

  const correctCount = test.questions.filter((q) => {
  const userAns = answers[q._id];

  if (userAns === undefined) return false;

  if (q.type === "text") {
    return (
      userAns?.toLowerCase().trim() ===
      q.answer?.toLowerCase().trim()
    );
  }

  return userAns === getCorrectAnswer(q);
}).length;

const handleDownloadPDF = () => {
  const pdf = new jsPDF();

  // Title
  pdf.setFontSize(18);
  pdf.text(test.title, 14, 20);

  pdf.setFontSize(12);
  pdf.text(test.description || "", 14, 28);

  pdf.text(`Score: ${correctCount} / ${test.questions.length}`, 14, 38);
  pdf.text(`Accuracy: ${accuracy}%`, 14, 45);

  const tableData = test.questions.map((q, index) => {
    const userAns = answers[q._id];

    const correctAnswer =
      q.type === "text"
        ? q.answer
        : q.options[getCorrectAnswer(q)]?.text;

    const userAnswer =
      userAns === undefined
        ? "Not Attempted"
        : q.type === "text"
        ? userAns
        : q.options[userAns]?.text;

    return [
      index + 1,
      q.question,
      userAnswer,
      correctAnswer
    ];
  });

  autoTable(pdf, {
    startY: 55,
    head: [["#", "Question", "Your Answer", "Correct Answer"]],
    body: tableData,
    styles: {
      fontSize: 8,
      cellPadding: 3
    },
    headStyles: {
      fillColor: [41, 128, 185]
    }
  });

  pdf.save(`${test.title}-result.pdf`);
};


const wrongCount = test.questions.filter((q) => {
  const userAns = answers[q._id];

  if (userAns === undefined) return false;

  if (q.type === "text") {
    return (
      userAns?.toLowerCase().trim() !==
      q.answer?.toLowerCase().trim()
    );
  }

  return userAns !== getCorrectAnswer(q);
}).length;

  const skippedCount = test.questions.length - (correctCount + wrongCount);

  const accuracy = ((correctCount / test.questions.length) * 100).toFixed(1);

  // ================= UI =================

  return (
    <div ref={pdfRef} className="min-h-screen bg-gray-100 p-6">

      {/* RESULT CARD */}
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 border">

        <h1 className="text-4xl font-bold text-blue-700 text-center">
          {test.title}
        </h1>

        <p className="text-gray-600 text-center mb-6">{test.description}</p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">

          <Stat title="Score" value={`${correctCount} / ${test.questions.length}`} color="blue" />
          <Stat title="Correct" value={correctCount} color="green" />
          <Stat title="Wrong" value={wrongCount} color="red" />
          <Stat title="Skipped" value={skippedCount} color="yellow" />

        </div>

        <div className="flex justify-center mt-5">
          <div className="px-6 py-2 bg-purple-100 text-purple-700 rounded-full text-lg font-semibold shadow">
            🎯 Accuracy: {accuracy}%
          </div>
        </div>

        <div className="flex gap-4 justify-center mt-8">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-700 hover:bg-gray-800 text-white rounded-xl shadow"
          >
            ⬅ Back
          </button>
          <button
  onClick={handleDownloadPDF}
  className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl shadow"
>
  📄 Download PDF
</button>

          <button
            onClick={() => navigate(`/tests/${test.type}/${id}`)}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl shadow"
          >
            🔄 Retry Test
          </button>
        </div>

      </div>

      {/* QUESTION REVIEW */}
      <div className="max-w-4xl mx-auto mt-10">

        <h2 className="text-3xl font-bold mb-4 text-gray-800">
          📘 Question Review
        </h2>

        {test.questions.map((q, index) => {
          const userAns = answers[q._id];
          const status = getStatus(q);

          return (
            <div
              key={q._id}
              className={`p-6 mb-5 rounded-xl shadow border
                ${
                  status === "correct"
                    ? "border-green-500 bg-green-50"
                    : status === "wrong"
                    ? "border-red-500 bg-red-50"
                    : "border-gray-300 bg-gray-50"
                }
              `}
            >

              <h3 className="font-bold text-lg mb-3">
                {index + 1}. {q.question}
              </h3>

              {q.type === "mcq" &&
                q.options.map((opt, i) => (
                  <div
                    key={i}
                    className={`p-3 rounded-lg border mb-2
                      ${
                        i === getCorrectAnswer(q)
                          ? "border-green-500 bg-green-100 font-semibold"
                          : i === userAns
                          ? "border-red-500 bg-red-100"
                          : "border-gray-300"
                      }
                    `}
                  >

                    <div>{opt.text}</div>

                    {opt.media?.url && (
                      <img
  crossOrigin="anonymous"
  src={`${process.env.REACT_APP_API_BASE_URL}${opt.media.url}`}
  alt=""
  className="mt-2 max-w-xs rounded border"
/>
                    )}

                  </div>
                ))}

              <div className="mt-4 p-3 rounded-lg bg-white shadow border">

                <p>
  <b>Your Answer:</b>{" "}
  {
    userAns === undefined
      ? "Not Attempted"
      : q.type === "text"
      ? userAns
      : q.options[userAns]?.text
  }
</p>

                <p className="mt-2 text-green-700 font-semibold">
                  Correct Answer: {
  q.type === "text"
    ? q.answer
    : q.options[getCorrectAnswer(q)]?.text
}
                </p>

              </div>

            </div>
          );
        })}

      </div>

    </div>
  );
}

// ================= SMALL STAT COMPONENT =================

function Stat({ title, value, color }) {
  const colors = {
    blue: "bg-blue-100 text-blue-800",
    green: "bg-green-100 text-green-800",
    red: "bg-red-100 text-red-700",
    yellow: "bg-yellow-100 text-yellow-700",
  };

  return (
    <div className={`p-5 rounded-xl shadow text-center ${colors[color]}`}>
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-3xl font-bold mt-1">{value}</p>
    </div>
  );
}